import React, { useMemo } from 'react';
import { Select } from 'antd';
import { allDimensionsListSelector } from '@store/common/dimensionList/selectors';
import { useSelector } from 'react-redux';
import { SelectGroupLabel, StyledSelector } from './styled';
import { getIcon4SelectOption } from '@src/components/common/DrillDownToEventScope';
import { DefaultOptionType } from 'antd/es/select';
import { dimensionsCategory } from '@src/utils/dimension/dimensionCategories';
import { CURRENT_PRODUCT_MODE } from '@src/utils/constants';
import { useDimensionOperations } from '../hooks/useDimensionOperations';
import DimensionBetaLabel from '../dimensionSelectorPopup/DimensionBetaLabel';

const dimensionListCategory = dimensionsCategory[CURRENT_PRODUCT_MODE];

function DimensionSelector({
  dimension,
  disabled = false,
  hiddenDimensions = [],
}: {
  dimension: string;
  disabled?: boolean;
  hiddenDimensions?: string[];
}) {
  const dimensions: any = useSelector(allDimensionsListSelector);
  const { updateDimension } = useDimensionOperations();
  const handleChange = (newDimension) => {
    updateDimension(dimension, newDimension);
  };

  const options = useMemo(() => {
    let selectOptions: DefaultOptionType[] = [];
    const dimensionOption = (d) => {
      return {
        name: d.name,
        label: d.name,
        value: d.groupBy,
        disabled: hiddenDimensions?.includes(d.groupBy as string),
      };
    };
    const dimensionByCategory: object = {};
    for (const dimension of dimensions ?? []) {
      const { category } = dimension;
      if (category) {
        if (!Array.isArray(dimensionByCategory[category])) {
          dimensionByCategory[category] = [];
        }

        dimensionByCategory[category].push(dimension);
      }
    }
    if (Object.keys(dimensionByCategory).length > 0) {
      selectOptions = Object.entries(dimensionByCategory).map<DefaultOptionType>(
        ([category, dimensionList]) => {
          return {
            label: (
              <SelectGroupLabel>
                {getIcon4SelectOption(category)}
                {dimensionListCategory[category] || category}
              </SelectGroupLabel>
            ),
            value: category,
            options: dimensionList
              .sort((a, b) => a.name.localeCompare(b.name))
              .map(dimensionOption)
              .filter((it) => !it.disabled),
          };
        },
      );
    } else {
      selectOptions = dimensions
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(dimensionOption)
        .filter((it) => !it.disabled);
    }
    return selectOptions;
  }, [dimensions, hiddenDimensions]);

  return (
    <StyledSelector>
      <Select
        showSearch
        options={options}
        optionFilterProp="name"
        optionRender={(option) => (
          <DimensionBetaLabel
            name={String(option.data?.name ?? '')}
            groupBy={String(option.value ?? '')}
          />
        )}
        value={dimension}
        onChange={handleChange}
        style={{
          width: 280,
          fontSize: '18px',
        }}
        variant="borderless"
        disabled={disabled}
        styles={{ popup: { root: { minWidth: 280 } } }}
      />
    </StyledSelector>
  );
}

export default DimensionSelector;
